import utmTracking from "./utm-tracking.js";

export default class CampaignSource {
    constructor() { }

    setCampaignName() {
        $("form").each(function () {
            const $form = $(this);
            const campaignNameField = $form.find("input[value=campaignName]");

            if (campaignNameField.length) {
                const campaignName = this.getCampaignName();
                if (campaignName !== "null") {
                    $(campaignNameField).val(campaignName);
                } else {
                    $(campaignNameField).val("");
                }
            }
        });
    }

    getCampaignSourceValue() {
        var utmCampaign;

        if (utmTracking.utmPresentInUrl()) {
            utmCampaign = utmTracking.getParameterByName("utm_campaign");
        } else {
            utmCampaign = utmTracking.utmCampaign();
        }

        if (!utmCampaign) {
            return "";
        }

        return decodeURI(utmCampaign);
    }

}
